import type {CSSProperties, ReactElement} from 'react'
// Types
import type {BallotPageBlock} from '../../types/ballot'

interface TextBlockProps {
  block: BallotPageBlock
}

const textStyle: CSSProperties = {whiteSpace: 'pre-line'}

const TextBlock = ({block}: TextBlockProps): ReactElement | null => {
  const text = block.formValuesObject.blockText || block.formValuesObject.blockRenderedText

  if (!text) return null

  return <div style={textStyle}>{text}</div>
}

export default TextBlock
